// 重新导出公共类型
export * from './types';
// 重新导出主服务类
export { NotificationService } from './NotificationService';
// 导出适配器（如果需要）
export { CapacitorNotificationAdapter } from './adapters/CapacitorAdapter';
export { WebNotificationAdapter } from './adapters/WebAdapter';
export { SimpleAdapter } from './adapters/SimpleAdapter';
export { FCMAdapter } from './adapters/FCMAdapter';

// 默认导出通知服务单例
import { NotificationService } from './NotificationService';
export default NotificationService.getInstance();